import DoughnutChart from "../../components/admin/DoughnutChart";
import AdminCards from "../../components/admin/DashBoardCards";
import { useEffect } from "react";

const AdminDashboard = () => {

  useEffect(()=>{
    document.body.style.backgroundColor = '#f5f5f5';

    return () => {
      document.body.style.backgroundColor = '#fff';
    }
  }, [])
  const CardsData = [
    {
      id: 1218,
      title: "Leads",
      desc: "Keep track of All Leads",
      allLink: "/admin/leads",
      image:"/icons/leads.png"
    },
    {
      id: 1211,
      title: "Estimates",
      desc: "Keep track of All Estimates",
      allLink: "/admin/estimates",
      image:"/icons/estimates.png"
    },
    {
      id: 1221,
      title: "Tickets",
      desc: "Keep track of All Tickets",
      allLink: "/admin/tickets",
      image:"/icons/ticket.png"
    },
    {
      id: 1222,
      title: "Invoices",
      desc: "Keep track of All Invoices",
      allLink: "/admin/invoices",
      image:"/icons/invoice.png"
    },
  ];

  const labelData = ["Leads", "Estimates", "Tickets"];

  const dataSetValue = [10, 15, 12];

  return (
    <div className="my-4 mx-4">
      <h2 className="mb-3 mx-1">Dashboard</h2>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <div className="card border_bg_color card_radius d-flex justify-content-center align-items-center pb-4">
            {/* <h4 className="pt-4 text-start w-100 px-4">Total Counts</h4> */}
            <DoughnutChart labelData={labelData} dataSetValue={dataSetValue} chartName={"Total Counts"} />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <div className="card  border_bg_color card_radius d-flex justify-content-center align-items-center pb-4">
            {/* <h4 className="pt-4 text-start w-100 px-4">Leads Generated</h4> */}
            <DoughnutChart labelData={labelData} dataSetValue={dataSetValue} chartName={"Leads Generated"} />
          </div>
        </div>
      </div>
      <div className="row mt-3">
        {CardsData.length > 0 &&
          CardsData.map((item) => {
            return (
              <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <AdminCards CardData={item} />
              </div>
            );
          })}
        {/* <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          
          <div className="card bg_color_gray border_bg_color card_radius d-flex justify-content-center align-items-center">
              <p>
                View Leads
              </p>
              <button className="btn btn-sm card_radius bg-black text-white">
                Go to Leads
              </button> 
          </div>
        </div>
        <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <div className="card bg_color_gray border_bg_color card_radius d-flex justify-content-center align-items-center">
            hello
          </div>
        </div>
        <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <div className="card bg_color_gray border_bg_color card_radius d-flex justify-content-center align-items-center">
            hello
          </div>
        </div>
        <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <div className="card bg_color_gray border_bg_color card_radius d-flex justify-content-center align-items-center">
            hello
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default AdminDashboard;
